import React from 'react';
import { date_formats, time_formats } from '../Utils/constants';
import moment from 'moment';
import '../Style/components.css';
export default function Settings(props) {
  return (
    <div
      style={props.settings.show ? { display: 'block' } : { display: 'none' }}
      className="menu"
    >
      <div className="close" onClick={() => props.setting_show(false)}>
        <i className="fi-rr-cross"></i>
      </div>
      <h3 className="head_text">Settings</h3>
      <div className="setting_body">
        <div className="setting_item">
          <h4>Localization:</h4>
          <h5>Date Format: </h5>
          <select
            onChange={(e) => {
              props.change_settings({
                ...props.settings,
                localization: {
                  ...props.settings.localization,
                  date_format: e.target.value,
                },
              });
            }}
            value={props.settings.localization.date_format}
          >
            {date_formats.map((date, i) => (
              <option key={i} value={date}>
                {date}
              </option>
            ))}
          </select>
          <br />
          <h5>Time Format: </h5>
          <select
            onChange={(e) => {
              props.change_settings({
                ...props.settings,
                localization: {
                  ...props.settings.localization,
                  time_format: e.target.value,
                },
              });
            }}
            value={props.settings.localization.time_format}
          >
            {time_formats.map((time, i) => (
              <option key={i} value={time}>
                {time}
              </option>
            ))}
          </select>
          <br />
          <h5>Default Language: English(IN)</h5>
          <h5>
            Date and Time:{' '}
            {moment(props.settings.localization.date).format(
              'DD/MM/YYYY hh:mm A'
            )}
            (System Time)
          </h5>
        </div>

        <div className="setting_item">
          <h4>Network</h4>
          <h5>
            Status:{' '}
            {navigator.onLine ? (
              <font color="green">Connected</font>
            ) : (
              <font color="red">DisConnected</font>
            )}
          </h5>
          <h5>
            Downlink:{' '}
            {navigator.connection ? navigator.connection.downlink : 'undefined'}
          </h5>
          <h5>
            Effective Speed type:{' '}
            {navigator.connection
              ? navigator.connection.effectiveType
              : 'undefined'}
          </h5>
        </div>
        <div className="setting_item">
          <h4>System</h4>
          <h5>Platform: {navigator.platform}</h5>
          <h5>App Version: {navigator.appVersion}</h5>
        </div>
        <div className="setting_item">
          <h4>Device Settings</h4>
          <h5>
            Location:{' '}
            {/* {navigator.geolocation.getCurrentPosition((info) => (
              <>
                <p>Accuracy{info.coords.accuracy}</p>
                <p>Altitude{info.coords.altitude}</p>
                <p>Accuracy{info.coords.accuracy}</p>
              </>
            ))} */}
            ...
          </h5>
          <h5>Camera/Microphone: ...</h5>
          <h5>Other Devices: ...</h5>
        </div>
        <div className="setting_item">
          <h4>About</h4>
          <h5>Thankyou for using this interface</h5>
        </div>
      </div>
    </div>
  );
}
